import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { 
  TicketStatus, 
  getAvailableStatusTransitions, 
  STATUS_LABELS 
} from '@/utils/statusTransitions';

interface StatusSelectProps {
  currentStatus: TicketStatus;
  value: TicketStatus;
  onValueChange: (value: TicketStatus) => void;
  disabled?: boolean;
  className?: string;
}

export const StatusSelect = ({
  currentStatus,
  value,
  onValueChange,
  disabled = false,
  className = '',
}: StatusSelectProps) => {
  const availableStatuses = getAvailableStatusTransitions(currentStatus);
  
  return (
    <Select
      value={value}
      onValueChange={(val) => onValueChange(val as TicketStatus)}
      disabled={disabled}
    >
      <SelectTrigger className={`w-full min-w-[130px] md:min-w-[180px] max-w-xs ${className}`}>
        <SelectValue placeholder="Selecione o status" />
      </SelectTrigger>
      <SelectContent>
        {availableStatuses.map((status) => (
          <SelectItem key={status} value={status}>
            {STATUS_LABELS[status]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default StatusSelect;
